import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { VideoCarousel } from '../VideoCarousel/VideoCarouselModal';

interface CustomCarouselSelectProps {
  moduleKey: string;
  selectedId: string;
  carousels: VideoCarousel[];
  onChange: (moduleKey: string, carouselId: string) => void;
}

export function CustomCarouselSelect({
  moduleKey,
  selectedId,
  carousels,
  onChange,
}: CustomCarouselSelectProps) {
  return (
    <FormControl size="small" sx={{ minWidth: 180 }}>
      <InputLabel id={`carousel-select-${moduleKey}`}>Välj karusell</InputLabel>
      <Select
        labelId={`carousel-select-${moduleKey}`}
        value={selectedId}
        label="Välj karusell"
        onChange={(e) => onChange(moduleKey, e.target.value)}
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <MenuItem value="">
          <em>Välj karusell</em>
        </MenuItem>
        {carousels.map((carousel) => (
          <MenuItem key={carousel.id} value={carousel.id}>
            {carousel.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
